import { ProductsMapper } from '../../../models/Products/ProductsMapper.js';
import { Content } from '../../../models/Content/Content.js';
import { PriceDetailMapper } from '../../../models/Price/PriceDetailMapper.js';

class Products {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(from, to, parcel, service, content, insurance, voucher, cod, priority) {
    const payload = {
      content: content ? content.getCreatePayload() : Content.deserialize({}).getCreatePayload(),
      from: from.getCreatePayload(),
      insurance: !!insurance,
      packages: parcel.map(item => {
        const {
          height,
          length,
          weight,
          width
        } = item;
        return {
          height,
          length,
          weight,
          width
        };
      }),
      service_id: service.id,
      to: to.getCreatePayload(),
      ...(cod && {
        cash_on_delivery_amount: cod === null || cod === void 0 ? void 0 : cod.amount
      }),
      ...(voucher && {
        voucher_name: voucher === null || voucher === void 0 ? void 0 : voucher.name
      }),
      priority
    };
    return this.apiClient.post('com/shipments/products', payload).then(response => {
      var _response$data$summar, _response$data$summar2;
      return {
        summary: {
          total: PriceDetailMapper.createModelFromResponse(response.data.summary.total),
          products: {
            insurance: PriceDetailMapper.createModelFromResponse(response.data.summary.products.insurance),
            cashOnDelivery: PriceDetailMapper.createModelFromResponse(response.data.summary.products.cash_on_delivery),
            adultSignature: PriceDetailMapper.createModelFromResponse(response.data.summary.products.adult_signature),
            proofOfDelivery: PriceDetailMapper.createModelFromResponse(response.data.summary.products.proof_of_delivery),
            additionalHandling: PriceDetailMapper.createModelFromResponse(response.data.summary.products.additional_handling),
            porterage: PriceDetailMapper.createModelFromResponse(response.data.summary.products.porterage),
            voucher: {
              ...PriceDetailMapper.createModelFromResponse(response.data.summary.products.voucher),
              name: (_response$data$summar = (_response$data$summar2 = response.data.summary.products.voucher) === null || _response$data$summar2 === void 0 ? void 0 : _response$data$summar2.name) !== null && _response$data$summar !== void 0 ? _response$data$summar : ''
            },
            managementFee: PriceDetailMapper.createModelFromResponse(response.data.summary.products.management_fee),
            priority: PriceDetailMapper.createModelFromResponse(response.data.summary.products.priority)
          }
        },
        products: ProductsMapper.createModelFromResponse(response.data.products)
      };
    });
  }
}

export { Products };
//# sourceMappingURL=Products.js.map
